"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var nl = {
  'contractSelectorMessages.contractDetails': 'Contractgegevens',
  'contractSelectorMessages.discount': 'Korting',
  'contractSelectorMessages.items': 'Items',
  'contractSelectorMessages.lastModified': 'Laatst bijgewerkt',
  'contractSelectorMessages.lastModifiedBy': 'Laatst Bijgewerkt Door',
  'contractSelectorMessages.markup': 'Prijsstijging',
  'contractSelectorMessages.revision': 'Revisie',
  'createOptionStep.contractNamePlaceholder': 'bijv. Catalogusprijs voorwaarde met {name}',
  'createOptionStep.header': 'U heeft al catalogusprijscontracten met {name}. De producten of aan een bestaand contract toevoegen of een nieuwe aanmaken',
  'createOptionStep.newOptionButtonDescription': 'Een nieuw contract aanmaken met {name}',
  'createOptionStep.newOptionButtonTitle': 'Nieuw contract initiëren',
  'createOptionStep.updateExistingOptionButtonDescription': 'SKU´s aan bestaand contract toevoegen met {name}',
  'createOptionStep.updateExistingOptionButtonTitle': 'Bestaand contract bijwerken',
  'generalModal.backButtonText': 'Terug',
  'generalModal.closeButtonText': 'Afsluiten',
  'generalModal.defaultErrorCreationMessage': 'Fout bij het creëren van een catalogusprijscontract',
  'generalModal.financialFlowsSupport': 'Ondersteuning Financiële Stromen',
  'generalModal.forAssistanceText': 'voor assistentie',
  'generalModal.nextButtonText': 'Volgende',
  'generalModal.pleaseContactText': 'S.v.p. contact opnemen',
  'generalModal.termButtonCreatedStatus': 'Aangemaakt',
  'generalModal.termButtonCreatingStatus': 'Bezig met creëren',
  'generalModal.termButtonDefaultText': 'Ter goedkeuring zenden',
  'generalModal.title': 'Catalogusprijscontract initiëren',
  'generalModal.viewPendingContractText': 'Hier klikken om het lopende contract in de Contractmanager te bekijken',
  'listPriceConfirmStep.allSkusHaveContractsErrorMessage': 'Alle sku´s hebben een catalogusprijscontract tussen {merchantName} en {fulfillerName}',
  'listPriceConfirmStep.buyer': 'Koper',
  'listPriceConfirmStep.confirmContractDetails': 'Details van het Contract Bevestigen',
  'listPriceConfirmStep.discount': 'Korting',
  'listPriceConfirmStep.endDate': 'Einddatum',
  'listPriceConfirmStep.errorLoadingSkusMessage': 'Fout bij het SKU´s Laden',
  'listPriceConfirmStep.excludedSkus': 'Uitgesloten ({count})',
  'listPriceConfirmStep.includedSkus': 'Sku´s ({count})',
  'listPriceConfirmStep.markup': 'Prijsstijging',
  'listPriceConfirmStep.name': 'Naam',
  'listPriceConfirmStep.noEndDate': 'Geen einddatum',
  'listPriceConfirmStep.seller': 'Verkoper',
  'listPriceConfirmStep.skusHaveContractsWarning': 'Er bestaat al een catalogusprijscontract tussen {fulfillerName} en {merchantName} voor deze sku´s',
  'listPriceConfirmStep.startDate': 'Begindatum',
  'listPriceCreateStep.existingHeader': 'Uit Cataloguscontracten Selecteren met {name}',
  'listPriceCreateStep.newHeader': 'Overeenkomst naam geven',
  'listPriceInitiatorButton.listPriceInitiatorButtonText': 'Contract Initiëren',
  'listPriceInitiatorButton.noIdentityMessage': 'U heeft geen handelaars-id om deze actie uit te voeren',
  'listPriceInitiatorButton.noSkusSelectedMessage': 'Er dienen geldige SKU´s te worden geselecteerd vóór het creëren van een contract',
  'listPriceInitiatorButton.tooltipMessage': '{message}. Voor hulp neem contact op met {email}',
  'selectMerchantStep.header': 'De handelaar die producten koopt selecteren',
  'selectMerchantStep.merchantSelectLabel': 'Handelaar',
  'skuSelector.apiErrorTemplate': 'Fout tijdens {serviceComment}. (Responscode: {status})',
  'skuSelector.apiSceneServiceComment': 'bezig met uri scene ophalen',
  'skuSelector.apiSkuServiceComment': 'bezig met sku´s opzoeken',
  'skuSelector.csvDownloadLink': '{number} Totaal Sku´s (Hier klikken om CSV te downloaden)',
  'skuSelector.csvDownloadName': 'all_skus.csv',
  'skuSelector.currentlyViewingText': 'Momenteel bekijkt u',
  'skuSelector.descriptionFilterLabel': 'Beschrijving',
  'skuSelector.emptyBinPlaceholder': 'Producten op hun naam of SKU opzoeken en ze dan hier toevoegen.',
  'skuSelector.filterOptionsTitle': 'Filteropties',
  'skuSelector.nameFilterLabel': 'Naam',
  'skuSelector.removeSkuButtonText': 'SKU´s verwijderen',
  'skuSelector.searchFilterLabel': 'Op sleutelwoord filteren...',
  'skuSelector.skuBinNoFilterResult': "Geen resultaten gevonden voor '{filter}'.",
  'skuSelector.skuCardDisabledTooltip': 'De selector is momenteel uitgeschakeld. Dit product kan niet worden toegevoegd aan of verwijderd van uw lijst.',
  'skuSelector.skuCountText': 'van {totalCount} sku´s',
  'skuSelector.skuFilterLabel': 'Sku',
  'skuSelector.skuSearchAddSkuButtonText': 'SKU´s toevoegen',
  'skuSelector.skuSearchAddSkuPrompt': 'Wilt u meerdere sku´s tegelijk toevoegen?',
  'skuSelector.skuSearchBarHelpText': 'Begin hierboven te typen om producten op te zoeken',
  'skuSelector.skuSearchBarLabel': 'Type een productnaam of SKU',
  'skuSelector.skuSearchDefaultErrorMessage': 'Er is iets misgegaan',
  'skuSelector.skuSearchDetailedErrorMessage': '{error}. Probeer het opnieuw',
  'skuSelector.skuSearchNextButtonText': 'Volgende',
  'skuSelector.skuSearchNotFoundErrorMessage': "Geen producten gevonden voor '{query}'",
  'skuSelector.skuSearchPrevButtonText': 'Vorige',
  'skuSelector.uploadModalAddButtonText': '({totalCount}) toevoegen',
  'skuSelector.uploadModalAddError': 'De bovenstaande SKU´s konden niet worden toegevoegd omdat ze niet bestaan op het platform.  Ze kunnen spelfouten, zoals alfanumerieke tekens of onjuist hoofdlettergebruik, bevatten. Herzie deze en probeer het opnieuw.',
  'skuSelector.uploadModalAddTitle': 'SKU´s toevoegen',
  'skuSelector.uploadModalCloseButtonText': 'Afsluiten',
  'skuSelector.uploadModalHelpText': 'Een lijst met door spaties gescheiden SKU´s invoeren . Het tegelijkertijd verwerken van duizenden SKU´s kan enige tijd in beslag nemen. Indien uw aanzienlijke vertragingen ervaart, probeer dan verschillende kleinere uploads te doen.',
  'skuSelector.uploadModalRemoveButtonText': '({totalCount}) Verwijderen',
  'skuSelector.uploadModalRemoveError': 'De bovenstaande SKU´s konden niet worden verwijderd omdat ze als niet-verwijderbaar zijn gemarkeerd.',
  'skuSelector.uploadModalRemoveTitle': 'SKU´s verwijderen',
  'skuSelector.uploadModalSkuLabel': "SKU's",
  'skuSelector2.apiErrorTemplate': 'Fout tijdens {serviceComment}. (Responscode: {status})',
  'skuSelector2.apiSceneServiceComment': 'bezig met uri scene ophalen',
  'skuSelector2.apiSkuServiceComment': "Zoeken naar product-id's",
  'skuSelector2.csvDownloadLink': "{number} Totale product-ID's (klik hier om CSV te downloaden)",
  'skuSelector2.csvDownloadName': 'all_skus.csv',
  'skuSelector2.currentlyViewingText': 'Momenteel bekijkt u',
  'skuSelector2.descriptionFilterLabel': 'Beschrijving',
  'skuSelector2.emptyBinPlaceholder': 'Producten op hun naam of Product-ID opzoeken en ze dan hier toevoegen.',
  'skuSelector2.filterOptionsTitle': 'Filteropties',
  'skuSelector2.nameFilterLabel': 'Naam',
  'skuSelector2.removeSkuButtonText': "Product-id's verwijderen",
  'skuSelector2.searchFilterLabel': 'Op sleutelwoord filteren...',
  'skuSelector2.skuBinNoFilterResult': "Geen resultaten gevonden voor '{filter}'.",
  'skuSelector2.skuCardDisabledTooltip': 'De selector is momenteel uitgeschakeld. Dit product kan niet worden toegevoegd aan of verwijderd van uw lijst.',
  'skuSelector2.skuCountText': "van {totalCount} product-ID's",
  'skuSelector2.skuFilterLabel': 'Product-ID',
  'skuSelector2.skuSearchAddSkuButtonText': "Voeg product-ID's toe",
  'skuSelector2.skuSearchAddSkuPrompt': "Wilt u meerdere product-ID's tegelijk toevoegen?",
  'skuSelector2.skuSearchBarHelpText': 'Begin hierboven te typen om producten op te zoeken',
  'skuSelector2.skuSearchBarLabel': 'Type een productnaam of Product-ID',
  'skuSelector2.skuSearchDefaultErrorMessage': 'Er is iets misgegaan',
  'skuSelector2.skuSearchDetailedErrorMessage': '{error}. Probeer het opnieuw',
  'skuSelector2.skuSearchNextButtonText': 'Volgende',
  'skuSelector2.skuSearchNotFoundErrorMessage': "Geen producten gevonden voor '{query}'",
  'skuSelector2.skuSearchPrevButtonText': 'Vorige',
  'skuSelector2.uploadModalAddButtonText': '({totalCount}) toevoegen',
  'skuSelector2.uploadModalAddError': "De bovenstaande product-ID's kunnen niet worden toegevoegd omdat ze niet op het platform bestaan. Ze kunnen typefouten bevatten, zoals niet-alfanumerieke tekens of onjuist hoofdlettergebruik. Controleer ze en probeer het opnieuw.",
  'skuSelector2.uploadModalAddTitle': "Voeg product-ID's toe",
  'skuSelector2.uploadModalCloseButtonText': 'Afsluiten',
  'skuSelector2.uploadModalHelpText': "Voer een lijst met product-ID's in, gescheiden door spaties. Het kan even duren voordat duizenden product-ID's tegelijk zijn verwerkt. Als u aanzienlijke vertragingen ondervindt, probeer dan verschillende kleinere uploads.",
  'skuSelector2.uploadModalRemoveButtonText': '({totalCount}) Verwijderen',
  'skuSelector2.uploadModalRemoveError': "De bovenstaande product-ID's kunnen niet worden verwijderd omdat ze zijn gemarkeerd als niet-verwijderbaar.",
  'skuSelector2.uploadModalRemoveTitle': "Product-id's verwijderen",
  'skuSelector2.uploadModalSkuLabel': "Product-ID's"
};
var _default = nl;
exports.default = _default;